const delimiter = '.';

export function formaterDato(dato: Date | string): string | undefined {
	let datoObjekt = dato;

	if (!datoObjekt) {
		return undefined;
	}

	if (typeof datoObjekt == 'string') {
		datoObjekt = konverterTilDate(datoObjekt);
	}
	function normaliser(tall, sifre) {
		tall = String(tall);
		return new Array(sifre - tall.length + 1).join('0') + tall;
	}
	return [
		normaliser(datoObjekt.getDate(), 2),
		normaliser(datoObjekt.getMonth() + 1, 2),
		normaliser(datoObjekt.getFullYear(), 4),
	].join(delimiter);
}

function konverterTilDate(dato: string): Date {
	return new Date(Date.parse(dato));
}
